var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-xs-12 col-md-7 pl-0 pr-0 police-part"},[_c('span',{staticClass:"mr-10"},[_vm._v("国药控股上海生物医药有限公司")]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("\n        沪ICP备10213462号-8\n      ")])])])])
}]

export { render, staticRenderFns }